export default __webpack_public_path__ + "static/media/error_complete.7d5f8a10.png";